import { apiClient, signApiRequest } from ".";
import { useQuery } from "@tanstack/react-query";

export const getFetchPOAText = async ({
  credentials,
}: {
  credentials: unknown;
}) => {
  const signedRequest = await signApiRequest(
    "GET",
    `${import.meta.env.VITE_API_URL}/fmk/get-sign-text`,
    credentials
  );

  const response = await apiClient({
    url: `/fmk/get-sign-text`,
    method: "GET",
    headers: signedRequest?.options?.headers,
  });
  return response.data;
};

export const useGetFetchPOAText = ({
  credentials,
}: {
  credentials: unknown;
}) => {
  const fetchPOATextQuery = useQuery({
    queryKey: ["fetch-poa-text"],
    queryFn: () => getFetchPOAText({ credentials }),
  });
  return fetchPOATextQuery;
};
